<div class="relative w-full overflow-hidden rounded-[18px] rounded-bl-none bg-white p-5 shadow-sm">
  @if (disabled()) {
    <div class="absolute inset-0 z-10 cursor-not-allowed rounded-[18px] bg-white/60"></div>
  }
  @if (badge()) {
    <div class="mb-3">
      <bevvi-pill-badge [label]="badge()" />
    </div>
  }

  @if (title()) {
    <h3
      class="mb-3 text-base font-semibold leading-snug text-solid-black-500"
      [innerHTML]="title() | markdown"
    ></h3>
  }

  @if (description()) {
    <div
      class="markdown-body text-sm leading-normal text-solid-black-500/70"
      [innerHTML]="description() | markdown"
    ></div>
  }

  @switch (type()) {
    @case ('text') {}

    @case ('confirmation') {
      <div class="mt-5 flex items-center justify-end gap-2">
        <bevvi-cta-button
          [label]="secondaryButtonText()"
          [variant]="CTAButtonVariant.OUTLINE"
          (buttonClick)="secondaryClick.emit()"
        />
        <bevvi-cta-button
          [label]="primaryButtonText()"
          [variant]="CTAButtonVariant.FILLED"
          (buttonClick)="submitClick.emit()"
        />
      </div>
    }

    @case ('select') {
      <div class="mt-4 flex flex-col gap-2">
        @for (option of options(); track option.id) {
          <button
            type="button"
            (click)="toggleOption(option.id)"
            class="w-full cursor-pointer rounded-full border px-3 py-1.5 text-left text-sm tracking-wide transition-all duration-200 hover:border-solid-teal-500 hover:bg-[color-mix(in_srgb,var(--bot-secondary,#004251)_10%,transparent)]"
            [style.background-color]="
              option.selected
                ? 'color-mix(in srgb, var(--bot-secondary, #004251) 20%, transparent)'
                : 'transparent'
            "
            [style.border-color]="option.selected ? 'var(--bot-secondary, #004251)' : '#E2E0D8'"
            [style.color]="
              option.selected ? 'var(--bot-secondary, #004251)' : 'var(--bot-primary, #100F0D)'
            "
          >
            {{ option.label }}
          </button>
        }
      </div>
    }

    @case ('multiselect') {
      <div class="mt-4 flex flex-wrap gap-2">
        @for (option of options(); track option.id) {
          <bevvi-option-chip
            [label]="option.label"
            [selected]="option.selected ?? false"
            [mode]="optionChipMode.MULTIPLE"
            (selectedChange)="toggleOption(option.id)"
          />
        }
      </div>

      @if (showActions()) {
        <div class="mt-4 flex justify-end">
          <bevvi-cta-button
            [label]="primaryButtonText()"
            [variant]="CTAButtonVariant.FILLED"
            (buttonClick)="submitClick.emit()"
          />
        </div>
      }
    }

    @case ('order-summary') {
      <div class="mt-4 space-y-4">
        @for (item of orderItems(); track item.id) {
          <div class="border-b border-solid-gray-500 pb-4">
            <div class="mb-2 flex items-start justify-between gap-3">
              <h4 class="text-sm font-medium leading-snug text-solid-black-500">
                {{ item.title }}
              </h4>
              <span class="shrink-0 text-xs text-solid-amber-500">Qty: {{ item.quantity }}</span>
            </div>

            <div class="flex items-center justify-between">
              @if (item.tag) {
                <bevvi-pill-badge [label]="item.tag" textColor="#C93030" strokeColor="#C93030" />
              }
              <span class="text-sm font-medium">{{ item.price | currency }}</span>
            </div>
          </div>
        }

        <div class="flex items-center justify-between text-base font-semibold">
          <span>Total amount</span>
          <span>{{ totalAmount() | currency }}</span>
        </div>

        @if (showActions() && (secondaryButtonText() || primaryButtonText())) {
          <div class="flex justify-end gap-2">
            @if (secondaryButtonText()) {
              <bevvi-cta-button
                [label]="secondaryButtonText()"
                [variant]="CTAButtonVariant.OUTLINE"
                (buttonClick)="secondaryClick.emit()"
              />
            }
            @if (primaryButtonText()) {
              <bevvi-cta-button
                [label]="primaryButtonText()"
                [variant]="CTAButtonVariant.FILLED"
                (buttonClick)="submitClick.emit()"
              />
            }
          </div>
        }
      </div>
    }

    @case ('time-slot') {
      <div class="mt-4 space-y-4">
        @for (group of slotGroups(); track group.title) {
          <div>
            <h4 class="mb-2 text-xs font-semibold uppercase tracking-wide text-solid-black-500/50">
              {{ group.title }}
            </h4>
            <div class="flex flex-wrap gap-2">
              @for (slot of group.slots; track slot.id) {
                <bevvi-option-chip
                  [label]="slot.label"
                  [selected]="slot.selected ?? false"
                  [mode]="optionChipMode.SINGLE"
                  (selectedChange)="toggleOption(slot.id)"
                />
              }
            </div>
          </div>
        }

        @if (showActions()) {
          <div class="flex justify-end">
            <bevvi-cta-button
              [label]="primaryButtonText()"
              [variant]="CTAButtonVariant.FILLED"
              (buttonClick)="submitClick.emit()"
            />
          </div>
        }
      </div>
    }
  }
</div>
